import { EmailTemplateAttachment } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const uploadEmailTemplateAttachment: (
  fetchContext: FetchContext,
  programId: number,
  emailTemplateId: number,
  attachmentFile: File,
  accessToken?: string,
) => Promise<EmailTemplateAttachment> = (fetchContext, programId, emailTemplateId, attachmentFile, accessToken) => {
  const formData = new FormData();
  formData.append('attachment', attachmentFile);

  return fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates/${emailTemplateId}/attachment`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  }).then((response) => responseErrorHandler<EmailTemplateAttachment>(fetchContext.errorStore, response, 'upload email template attachment'));
};
